import React from 'react';
import './dropdown.scss';

class DropDown extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      selectedValue: 'Please select',
      options: props.options
    };

    this.handleDropDownSelect = this.handleDropDownSelect.bind(this);
    this.toggleDropDown = this.toggleDropDown.bind(this);
    this.handleToggleDropdown = this.handleToggleDropdown(this);
  }
  componentWillMount() {
    if(this.props.inputValue){
      this.setState({ selectedValue: this.getSelectedValue(this.props.inputValue) });
    }
  }
  getSelectedValue = (value)=>(this.state.options.find(number => number.toLowerCase() === value.toLowerCase()));
  toggleDropDown(e){
    e.preventDefault();
    this.setState({
      show: !this.state.show
    });
  }

  handleDropDownSelect(e, selectedIndex) {
    e.preventDefault();
    let selectedVal=this.state.options[selectedIndex];
    this.props.selectedOption(selectedVal);
    this.setState({
      show: !this.state.show,
      selectedValue: selectedVal,
      options: this.state.options
    });

  }

  handleToggleDropdown(e) {
    if(e.keyCode === 13) {
      this.toggleDropDown();
    } else if (e.keyCode === 32){
      this.setState({
        show: true
      });
    } else if (e.keyCode === 27){
      this.setState({
        show: false
      });
    }
  }

  render() {
    const { options, show, selectedValue } = this.state;
    let dropdownBody = document.getElementById(this.props.bodyId);
    let currentIndex = 0;
    return (
      <div className="cl-dropdown-wrapper">
        <div className="cl-dropdown-header" data-track="app-start2" onClick={this.toggleDropDown}
          onKeyDown={e=>{
            let key=e.keyCode;
            key===13?this.setState({ show: !this.state.show }):null;
            key===32?this.setState({ show: true }):null;
            key===27?this.setState({ show: false }):null;
            if((key===38||key===40||key==13||key===32)&&!this.state.show){
              this.setState({ show: true }, ()=>{
                this.setState({ show: true });
              });
            } else if((key===38||key===40||key==13||key===32)&&this.state.show){
              let childNodes = dropdownBody && dropdownBody.children;
              childNodes && childNodes[0].focus(options);
            }
          }} tabIndex={this.props.tabIndex} aria-label="Dropdown" role="combobox" aria-controls={this.props.bodyId} aria-expanded={show}>
          <span className="standard-blue">{selectedValue}</span>
          <div className={show ? "arrow-down" : "arrow"} />
        </div>
        {
          show ? <div className="cl-dropdown-body" id={this.props.bodyId} role="listbox" aria-label="Please select from the list">
            {
              options&&options.map((item, index)=>{
                return <div className="cl-dropdown-content" key={`dropdown-options-${index}`} onClick={e=>this.handleDropDownSelect(e, index)} tabIndex="0"
                  onKeyDown={e=>{
                    if(this.state.show) {
                      let key = e.keyCode;
                      let min = 0;
                      let max = dropdownBody.childElementCount;
                      if (key === 38) {
                        currentIndex > min ? currentIndex-- : null;
                      } else if (key === 40) {
                        currentIndex < max ? currentIndex++ : null;
                      }
                      let childNodes = dropdownBody && dropdownBody.children;
                      childNodes[currentIndex].focus(options);
                      if(key === 13 || key === 32) {
                        this.handleDropDownSelect(e, index);
                      }
                    }
                  }} role="option">
                  <span>{item}</span>
                </div>;
              })
            } </div>: null
        }
      </div>
    );
  }
}

export default DropDown;
